var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5601 0.0147218C28.9597 -0.0412586 29.2528 0.0707019 29.6524 0.210653C31.1444 0.742466 31.8637 2.42188 31.4108 3.98933C30.9579 5.52879 28.7466 12.4983 28.7466 14.0098C28.7466 15.4933 30.7447 16.8088 32.3432 16.8088H40.3358C41.9343 16.8088 43 17.9284 43 19.6079C43 21.2873 37.6716 39.201 37.6716 39.201C37.2187 40.2926 36.2063 42 35.0074 42H10.6568V16.8088H16.3581C17.4504 15.6612 25.1499 3.62546 25.8959 2.05801C26.4554 0.910408 27.4944 0.154673 28.5601 0.0147218ZM0 16.8088H5.32838V42H0V16.8088Z",
    fill: "#00A8A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpGreen);
export default __webpack_public_path__ + "static/media/thumbs-up-green.28835cf360cedd2051eef04c631ca95d.svg";
export { ForwardRef as ReactComponent };